module.exports = __webpack_public_path__ + "static/media/gde.55dba61e.webp";